'use client';
import { motion } from 'framer-motion';
import type { ReactElement } from 'react';
import { GanttBarSegment } from './GanttBarSegment';
import { GanttBarTrack } from './GanttBarTrack';
import type { GanttBarRenderModel } from './gantt-bar-selectors';
export interface GanttBarMotionGroupProps {
    renderModel: GanttBarRenderModel;
}
export function GanttBarMotionGroup({ renderModel, }: GanttBarMotionGroupProps): ReactElement {
    return (
      <motion.g initial={renderModel.motion.initial} animate={renderModel.motion.animate} transition={renderModel.motion.transition} style={renderModel.motion.style} filter={renderModel.motion.filter}>
        <GanttBarTrack track={renderModel.track}/>
        {renderModel.segments.map((segment) => (<GanttBarSegment key={segment.kind} segment={segment}/>))}
      </motion.g>
    );
}
